export default __webpack_public_path__ + "static/media/Approve.de9d0003.svg";